import { Navigate, useLocation } from "react-router-dom";
import { useAuth, roleHome } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Guard React routes based on authentication state and optional role.
 * @param {("admin"|"customer")=} role — if provided, only that role may access.
 */
export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        <Loader2 className="w-5 h-5 animate-spin mr-2" />
        Sitzung wird geprüft…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (role && user.role !== role) {
    return <Navigate to={roleHome(user.role)} replace />;
  }
  return children;
}
